module.exports = __webpack_public_path__ + "img/72_11.4578620f.png";